import { useCallback, useReducer } from "react";
import i18n from "../../../../services/localization-service/i18n";

export type RoleOptionType = {
    id: number;
    name: string;
};

export const ALL_ROLES_OPTION_ID = -1;
export const allRolesOption: RoleOptionType = {
    id: ALL_ROLES_OPTION_ID,
    name: i18n.t("uiCustomizationPresetEditor.steps.membership.allRolesOption")
};

export type MembershipStepStateType = {
    filterValue: string;
    viewSelected: boolean;
    selectedRoles?: Array<RoleOptionType>;
};

enum MembershipStepActionType {
    FilterValueChanged = "FILTER_VALUE_CHANGED",
    ViewSelectedChanged = "VIEW_SELECTED__CHANGED",
    SelectedRolesChanged = "SELECTED_ROLES_CHANGED",
    ResetChanged = "MEMBERSHIP_RESET"
}

type MembershipStepAction = {
    type: MembershipStepActionType.FilterValueChanged;
    filter: string;
} | {
    type: MembershipStepActionType.ViewSelectedChanged;
    enabled: boolean;
} | {
    type: MembershipStepActionType.SelectedRolesChanged;
    selectedRoles: Array<RoleOptionType>;
} | {
    type: MembershipStepActionType.ResetChanged;
    payload: void;
};

const initialState: MembershipStepStateType = {
    filterValue: "",
    viewSelected: false,
    selectedRoles: [allRolesOption]
};

function MembershipStepReducer(state: MembershipStepStateType, action: MembershipStepAction): MembershipStepStateType {
    switch (action.type) {

        case MembershipStepActionType.FilterValueChanged:
            return {
                ...state,
                filterValue: action.filter
            };

        case MembershipStepActionType.ViewSelectedChanged:
            return {
                ...state,
                viewSelected: action.enabled
            };

        case MembershipStepActionType.SelectedRolesChanged:
            return {
                ...state,
                selectedRoles: action.selectedRoles
            };

        case MembershipStepActionType.ResetChanged:
            return {...initialState}

        default:

            return state;
    }
}

export type UseMembershipStepStateType = {
    state: MembershipStepStateType;
    setFilterValue: (filterValue: string) => void;
    setViewSelected: (viewSelected: boolean) => void;
    setSelectedRoles: (selectedRoles: Array<RoleOptionType>) => void;
    reset: () => void;
};

export function useMembershipStepState(): UseMembershipStepStateType {

    const [state, dispatch] = useReducer(MembershipStepReducer, initialState);

    const setFilterValue = useCallback((filterValue: string) => dispatch({
        type: MembershipStepActionType.FilterValueChanged,
        filter: filterValue
    }), []);

    const setViewSelected = useCallback((viewSelected: boolean) => dispatch({
        type: MembershipStepActionType.ViewSelectedChanged,
        enabled: viewSelected
    }), []);

    const setSelectedRoles = useCallback((selectedRoles: Array<RoleOptionType>) => dispatch({
        type: MembershipStepActionType.SelectedRolesChanged,
        selectedRoles
    }), []);

    const reset = useCallback(() => {
            dispatch({
        type: MembershipStepActionType.ResetChanged,
        payload: undefined
        });
    },[]);

    return {
        state,
        setFilterValue,
        setViewSelected,
        setSelectedRoles,
        reset
    };
}
